import { Text } from "@chakra-ui/react";

export default function Overline({ children, ...rest }) {
  return (
    <Text fontWeight={500} fontSize="1.2rem" lineHeight="1" {...rest}>
      {children}
    </Text>
  );
}
